module.exports = __webpack_public_path__ + "static/media/kaltura-logo.870332da.png";